import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Logo } from '../components/Logo';
import { ResultsDisplay } from '../components/ResultsDisplay';
import { TrustBlock } from '../components/TrustBlock';
import { ArrowLeft, CheckCircle } from 'lucide-react';

export default function ResultsPage() {
  const navigate = useNavigate();
  const [leadData, setLeadData] = useState(null);

  useEffect(() => {
    // Get lead data from session storage
    const storedData = sessionStorage.getItem('leadData');
    if (storedData) {
      setLeadData(JSON.parse(storedData));
    } else {
      // Redirect to home if no data
      navigate('/');
    }
  }, [navigate]);

  if (!leadData) {
    return (
      <div className="min-h-screen bg-navy-950 flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-2 border-gold-400 border-t-transparent rounded-full" />
      </div>
    );
  }

  return (
    <div data-testid="results-page" className="min-h-screen bg-navy-950">
      {/* Noise overlay */}
      <div className="noise-overlay" />

      {/* Header */}
      <header className="relative z-10 border-b border-slate-800/30">
        <div className="max-w-7xl mx-auto px-6 py-10 md:py-12">
          <Logo size="default" />
        </div>
      </header>

      {/* Success Banner */}
      <div className="relative z-10 bg-emerald-500/10 border-b border-emerald-500/30">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-center gap-3">
          <CheckCircle className="w-5 h-5 text-emerald-400" />
          <span className="text-emerald-400 font-medium">
            Your Liquidity Diagnostic is Ready
          </span>
        </div>
      </div>

      {/* Main Content */}
      <main className="relative z-10 max-w-5xl mx-auto px-6 py-12 md:py-16">
        {/* Back Link */}
        <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-slate-400 hover:text-slate-200 transition-colors mb-8"
          data-testid="back-to-calculator-btn"
        >
          <ArrowLeft className="w-4 h-4" />
          <span className="text-sm">Back to Calculator</span>
        </button>

        {/* Personalized Header */}
        <div className="mb-12">
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-slate-50 mb-3">
            {leadData.first_name}'s Liquidity Diagnostic Report
          </h1>
          <p className="text-slate-400">
            Based on your financial profile, here's your personalized assessment and recommendations.
          </p>
        </div>

        {/* Results */}
        <ResultsDisplay leadData={leadData} />
      </main>

      {/* Trust Block Footer */}
      <TrustBlock />

      {/* Bottom Bar */}
      <footer className="bg-navy-950 border-t border-slate-800/50 py-6">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <p className="text-sm text-slate-400">
            © {new Date().getFullYear()} Sanam Bawa | <a href="mailto:sanam@everythingmortgages.ca" className="hover:text-gold-400 transition-colors">sanam@everythingmortgages.ca</a> | License #M15001292
          </p>
          <p className="text-xs text-slate-600 mt-2">
            This assessment is for educational purposes only and does not constitute financial advice.
          </p>
        </div>
      </footer>
    </div>
  );
}
